const Types = {
    SNACKBAR: "SNACKBAR",
    TOGGLE_THEME: "TOGGLE_THEME",
    GLOBAL_LOADER: "GLOBAL_LOADER",
    SHOW_PROGRESS_BAR: "SHOW_PROGRESS_BAR",
    PROGRESS_BAR_VALUE: "PROGRESS_BAR_VALUE",
    ALL_CREDENTIALS: "ALL_CREDENTIALS",
    ALL_SERVICES: "ALL_SERVICES",
    PROVISION_SELECTED_SERVICE: "PROVISION_SELECTED_SERVICE",
    PROVISION_SELECTED_CREDENTIAL: "PROVISION_SELECTED_CREDENTIAL",
    PROVISION_ADD_NEW: "PROVISION_ADD_NEW",
    TF_TO_JSON: "TF_TO_JSON",
    PLAN_TERRAFORM: "PLAN_TERRAFORM",
    APPLY_TERRAFORM: "APPLY_TERRAFORM",
    PROVISION_RESET: "PROVISION_RESET",
    PROVISION_ALL_OPERATIONS: "PROVISION_ALL_OPERATIONS",
    PROVISION_LOGS: "PROVISION_LOGS",
    PROVISION_COST_AND_SECURITY: "PROVISION_COST_AND_SECURITY",
    TERRAFORM_REGION: "TERRAFORM_REGION",
    AUTOMATION_ASSESSMENT: "AUTOMATION_ASSESSMENT",
    STATEFILE_SELECTED_SERVICE: "STATEFILE_SELECTED_SERVICE",
    STATEFILE_SELECTED_CREDENTIAL: "STATEFILE_SELECTED_CREDENTIAL",
    STATEFILE_IMPORT_SERVICES: "STATEFILE_IMPORT_SERVICES",
    STATEFILE_IMPORT_STATUS: "STATEFILE_IMPORT_STATUS",
    REGIONS_BY_ACCOUNT: "REGIONS_BY_ACCOUNT",
    ALL_USERS: "ALL_USERS",
    LOGGED_USER: "LOGGED_USER",
    ALL_AFT: "ALL_AFT",
    ALL_AFT_ACCOUNT_NAMES: "ALL_AFT_ACCOUNT_NAMES",
    ORGANIZATIONAL_UNITS: "ORGANIZATIONAL_UNITS",
    ASSESSMENT_HISTORY: "ASSESSMENT_HISTORY",
    COST_AND_SECURITY: "COST_AND_SECURITY",
    VULNERABILITY_DETAILS: "VULNERABILITY_DETAILS",
}
export default Types